import { render, staticRenderFns } from "./updateClassCount.vue?vue&type=template&id=418a6c2c&lang=pug"
import script from "./updateClassCount.vue?vue&type=script&lang=js"
export * from "./updateClassCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports